<mat-form-field class="cms-search input-form-field" appearance="outline" color="accent">
  <mat-icon matPrefix>search</mat-icon>
  <input matInput
         [placeholder]="placeholder"
         type="text"
         (keyup)="onSearch($event)">
</mat-form-field>
